<template>
<div class="bk-gray-dark  trick-4">
  <img src="../../../assets/images/preparare-formule/truc4.png" alt="/">
    <p>4. Nu uita să lași suficient spațiu în cănuță/biberon pentru amestecarea formulei </p>

    <span>Dacă recipientul este prea plin, formula nu va putea fi amestecată corect și dizolvarea completă va fi dificilă.
        Folosește un recipient de mărimea potrivită. De exemplu, la 30 ml de apă, cu o măsură de pudră de lapte, este recomandat
        să utilizezi un recipient cu o capacitate maximă de 150-160 ml. Ca să prepari 150 ml de apă cu 5 măsuri de pudră de lapte,
        poți utiliza un recipient cu o capacitate maximă de 300-350ml.</span>
</div>
</template>

<script>
export default {
    name: 'Amestecare',

    data() {
        return {}
    },
}
</script>
<style lang="scss" scoped>
.trick-4 p{
  margin-top: 50px;
  color: #17479E;
  font-size: 20px;
  font-weight: 600;
}

.trick-4 span{
  font-size: 16px;
  color: #17479e;
}

.trick-4 img {
  position: absolute;
  left: 20px;
  top: -60px;
}
@media screen and (max-width: 526px){
  .trick-4 img{
    width: 89px !important;
    height: 89px !important;
    top: -40px;
  }
}

</style>
